import {useParams} from 'react-router-dom'
import {useEffect, useState} from "react";
import {Spinner} from "../components";
import {parcelDetails} from "../services/service";

const Details = () => {
    const {id} = useParams()

    const [data, setData] = useState(false)


    const getData = async () => {


        const formData = new FormData();
        formData.append("tracking_code", id);

        const response = await parcelDetails(formData)
        if (response && response.data.code==1) {

            setData(response.data)
        }
    }



    useEffect(() => {
        getData()
    },[])


    let content

    if (data) {

        content = <>

            <div className='column is-12 lightborder  has-text-centered'>
                کد رهگیری :
                {'  '}
                {data.parcel.tracking_code}
            </div>
            <div className='column is-12 lightborder  has-text-centered'>
                مرکز پستی :
                {'  '}
                {data.logs[0].postcenter_name}
            </div>

            <div className='column lightborder is-6 '>
                تاریخ :
                {'  '}
                {data.logs[0].date}
            </div>
            <div className='column lightborder is-6 '>
                ساعت :
                {'  '}
                {data.logs[0].clock}
            </div>


            <div className='column lightborder is-6 '>
                فرستنده :
                {'  '}
                {data.parcel.sender_name}
            </div>

            <div className='column lightborder is-6 '>
                گیرنده :
                {'  '}
                {data.parcel.receiver_name}
            </div>

            <div className='column lightborder is-6 '>
                شماره فرستنده :
                {'  '}
                {data.parcel.sender_phone}
            </div>

            <div className='column lightborder is-6 '>
                شماره گیرنده :
                {'  '}
                {data.parcel.receiver_phone}
            </div>

            <div className='column lightborder is-6 '>
                شهر مبدا :
                {'  '}
                {data.receive_city.name}
            </div>

            <div className='column lightborder is-6 '>
                شهر مقصد :
                {'  '}
                {data.send_city.name}
            </div>


            <div className='column lightborder is-12  '>
                آدرس تحویل :
                {'  '}
                {data.parcel.address}
            </div>

            <div className='column lightborder is-6 '>
                تاریخ دریافت :
                {'  '}
                {data.logs[0].date}
            </div>


            <div className='column lightborder is-6 '>
                وزن :
                {'  '}
                {data.parcel.weight}
            </div>

            <div className='column lightborder is-12 '>
                توضیحات :
                {'  '}
                {data.parcel.notes}
            </div>


            <div className='column  is-12 has-text-centered mt-6 '>

                <button className='button yekan' onClick={() => window.print()}>
                    پرینت رهگیری مرسوله
                </button>
            </div>

        </>

    } else {
        content =

            <div className='is-flex is-justify-content-center'>
                <Spinner/>
            </div>

    }


    return (
        <>
        <div className='columns p-5 is-mobile  is-multiline yekan '>

                {
                    content
                }
            </div>


        </>
    )
}
export default Details;